import * as api from "./middleware/api.middleware";
import { getAuthHeader } from "./auth/authHeaders";
import {
  ReleaseNoteItem,
  ReleaseNoteReceipt,
  ReleaseNoteUnseenCount,
} from "../interfaces";

// Relative, so the middleware prefixes REACT_APP_API_URL like every other service.
const serviceUrl = "release-notes";
const getAccessToken = () => getAuthHeader();

export function getReleaseNotes(limit = 20) {
  return api.get<ReleaseNoteItem[]>(
    `${serviceUrl}?${new URLSearchParams({ limit: String(limit) })}`,
    getAccessToken()
  );
}

export function getUnseenReleaseNoteCount() {
  return api.get<ReleaseNoteUnseenCount>(
    `${serviceUrl}/unseen-count`,
    getAccessToken()
  );
}

// Returns the unseen count afterwards. Ids of unpublished notes are ignored by the backend.
export function markReleaseNotesSeen(releaseNoteIds: number[]) {
  return api.post<ReleaseNoteUnseenCount>(
    `${serviceUrl}/seen`,
    { release_note_ids: releaseNoteIds },
    getAccessToken()
  );
}

export function markReleaseNoteRead(releaseNoteId: number) {
  return api.post<ReleaseNoteReceipt>(
    `${serviceUrl}/${releaseNoteId}/read`,
    {},
    getAccessToken()
  );
}
